import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6cfc147a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./treatment-step-two.scss?vue&type=style&index=0&id=6cfc147a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfc147a",
  null
  
)

export default component.exports